import { dates } from './dates'

import { shipmentZonesStore } from '../store/shipmentZonesStore'
import { orderStore } from '../store/orderStore'
import { subscriptionStore } from '../store/subscriptionStore'
import { deliveryStore } from '../store/deliveryStore'

export const deliverySelect = {
	data () {
		return {
			shipmentZonesStore: shipmentZonesStore.state
		}
	},

	mixins: [dates],

	computed: {
		$_deliverySelect_deliveryDay () {
			if (!this.$_deliverySelect_selectedDelivery) return
			return this.$_dates_readableDate(this.$_deliverySelect_selectedDelivery.delivery_date_estimated).replace(/ .*/, '')
		},

		$_deliverySelect_getRealZoneShipment() {
			return this.shipmentZonesStore.shipmentZones.available[this.$_deliverySelect_selectedIndexDaySelect];
		},

	    $_deliverySelect_selectedDay() {

	      let i = this.shipmentZonesStore.shipmentZones.selectedIndex;

	      return i != null ? this.shipmentZonesStore.shipmentZones.available[i] : null;
	    },


	    $_deliverySelect_selectedIndexDaySelect() {

	      let i = this.shipmentZonesStore.shipmentZones.selectedIndex;

	      if (i == null) {
	        return this.$_deliverySelect_selectedIndexDay;
	      } else {
	        return i;
	      }
	    },

	    $_deliverySelect_selectedIndexDay() {

	      let delivery = deliveryStore.state.deliveries.order;

	      if (delivery.length == 0) {
	        return null;
	      }

	      delivery = delivery[0].attributes;

	      let i = this.shipmentZonesStore.shipmentZones.available.findIndex(option => {


	        if (orderStore.state.order) {
	          if(option.shipment_day != delivery.shipment_day || option.week_plan_id != orderStore.state.order.week_plan.id) {
	            return false;
	          }
	        }

	        return option.zone_id == delivery.shipment_zone_id;
	      })
	      return i == -1 ? 0 : i;
	    },
		$_deliverySelect_deliveryAvailable () {
			return this.shipmentZonesStore.shipmentZones.available.length > 0
		},
		$_deliverySelect_selectedDeliveryDay () {
			if (!this.$_deliverySelect_deliveryAvailable) return
			if (this.shipmentZonesStore.shipmentZones.selectedIndex === null) return

			return this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex].delivery_day_estimated % 7			
		},

		$_deliverySelect_selectedDelivery () {
			if (this.shipmentZonesStore.shipmentZones.available.length <= 0) return {}
			return this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex]
		},

		$_deliverySelect_isOnlyOption () {
			return this.shipmentZonesStore.shipmentZones.available.filter(r => r.delivery_day_estimated === this.$_deliverySelect_selectedDeliveryDay).length === 1
		},
	},

	watch: {
		'shipmentZonesStore.shipmentZones.selectedIndex' () {
			if (this.$_deliverySelect_isOnlyOption) {
				var delivery = this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex]
				this.$_deliverySelect_selectDeliveryType(delivery.zone_id)
			}
		}
	},

	methods: {
		$_deliverySelect_createWeek () {
      /*
			var week = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato']
			this.week = {}
			week.forEach((record, index) => {
				var num = index + 1
				this.week[num] = {}

				this.week[num].name = record
				this.week[num].num = num
			})
      */
		},

		$_deliverySelect_weekDayAvailable (dayNum) {
			if (!dayNum) return
			if (this.$_deliverySelect_deliveryAvailable) return this.shipmentZonesStore.shipmentZones.available.find(r => +r.delivery_day_estimated % 7 === +dayNum)
		},

		$_deliverySelect_selectDeliveryDay (dayNum) {

			var deliveryIndex = this.shipmentZonesStore.shipmentZones.available.findIndex(d => d.delivery_day_estimated % 7 === +dayNum)
			this.$_deliverySelect_selectDelivery(deliveryIndex)
		},

		$_deliverySelect_selectDeliveryType (zone) {
			if (!zone) return

			var deliveryIndex = this.shipmentZonesStore.shipmentZones.available.findIndex(d => d.delivery_day_estimated % 7 === +this.$_deliverySelect_selectedDeliveryDay && +d.zone_id === +zone)
			this.$_deliverySelect_selectDelivery(deliveryIndex)
		},

		$_deliverySelect_selectDelivery (deliveryIndex) {
			shipmentZonesStore.selectShipmentZoneIndex(deliveryIndex)

			var delivery = this.shipmentZonesStore.shipmentZones.available[this.shipmentZonesStore.shipmentZones.selectedIndex]

      if (!delivery) {
        return;
      }
      
      orderStore.updateOrderParam({ param: 'week_plan_id', value: delivery.week_plan_id })
			orderStore.updateOrderParam({ param: 'shipment_zone_id', value: delivery.zone_id })
			orderStore.updateOrderParam({ param: 'shipment_day', value: delivery.shipment_day })

			subscriptionStore.updateShipmentDay(delivery.shipment_day)
			subscriptionStore.updateShipmentZone(delivery.zone_id)
			subscriptionStore.updateShipmentCourier(delivery.courier.name)

			subscriptionStore.updateSubscriptionParam({ param: 'province', value: delivery.province })

		}
	},

	created () {
		this.$_deliverySelect_createWeek()
	}
}
